import api from 'api';

import moment from 'moment-business-days';
import { decisionManagerURL } from './utils';
import { httpErrorTypes } from 'utility/error';

export const FILTER_REQUEST = 'FILTER_REQUEST';
export const FILTER_SUCCESS = 'FILTER_SUCCESS';
export const FILTER_FAILURE = 'FILTER_FAILURE';
export const LOAD_DECISION_MANAGER_HISTORY_REQUEST = 'LOAD_DECISION_MANAGER_HISTORY_REQUEST';
export const LOAD_DECISION_MANAGER_HISTORY_SUCCESS = 'LOAD_DECISION_MANAGER_HISTORY_SUCCESS';
export const LOAD_DECISION_MANAGER_HISTORY_FAILURE = 'LOAD_DECISION_MANAGER_HISTORY_FAILURE';
export const EXPORT_DECISION_REQUEST = 'EXPORT_DECISION_REQUEST';
export const EXPORT_DECISION_SUCCESS = 'EXPORT_DECISION_SUCCESS';
export const EXPORT_DECISION_FAILURE = 'EXPORT_DECISION_FAILURE';
export const ASSIGN_DECISION_MANAGER_REQUEST = 'ASSIGN_DECISION_MANAGER_REQUEST';
export const ASSIGN_DECISION_MANAGER_SUCCESS = 'ASSIGN_DECISION_MANAGER_SUCCESS';
export const ASSIGN_DECISION_MANAGER_FAILURE = 'ASSIGN_DECISION_MANAGER_FAILURE';
export const LOAD_ASSIGNABLE_USERS_REQUEST = 'LOAD_ASSIGNABLE_USERS_REQUEST';
export const LOAD_ASSIGNABLE_USERS_SUCCESS = 'LOAD_ASSIGNABLE_USERS_SUCCESS';
export const LOAD_ASSIGNABLE_USERS_FAILURE = 'LOAD_ASSIGNABLE_USERS_FAILURE';
export const CLEAR_DECISION_MANAGER = 'CLEAR_DECISION_MANAGER';

export const decisionManagerActionErrorTypes = {
  LOAD_DECISION_MANAGER_FILTER: 'LOAD_DECISION_MANAGER_FILTER',
  LOAD_DECISION_MANAGER_HISTORY: 'LOAD_DECISION_MANAGER_HISTORY'
};

export const loadDecisionManagerFilter = () => {
  return {
    types: [FILTER_REQUEST, FILTER_SUCCESS, FILTER_FAILURE],
    callAPI: (state, { customerId, userId }) => api.fetch(decisionManagerURL('decisionmanagerfilter')),
    httpErrorTypes
  };
};

export const loadDecisionManagerHistory = (payload, endpoint, t) => (dispatch, getState) => {
  return dispatch({
    types: [
      LOAD_DECISION_MANAGER_HISTORY_REQUEST,
      LOAD_DECISION_MANAGER_HISTORY_SUCCESS,
      LOAD_DECISION_MANAGER_HISTORY_FAILURE
    ],
    callAPI: (state, { customerId, userId }) => api.save(decisionManagerURL(endpoint), payload),
    httpErrorTypes: {
      DEFAULT: decisionManagerActionErrorTypes.LOAD_DECISION_MANAGER_HISTORY,
      404: {
        type: decisionManagerActionErrorTypes.LOAD_DECISION_MANAGER_HISTORY,
        message: t('decisionManager.messages.noSuspendedTransactionsFound')
      }
    }
  });
};

export const exportDecisions = (payload, reportType = '', t) => (dispatch, getState) => {
  return dispatch({
    types: [EXPORT_DECISION_REQUEST, EXPORT_DECISION_SUCCESS, EXPORT_DECISION_FAILURE],
    callAPI: (state, { customerId, userId }) =>
      api.save(
        `txndecisionmanagersvc/v0/cust/${customerId}/user/${userId}/decision/export/${reportType}-data`,
        payload
      ),
    httpErrorTypes,
    errorDisplayType: 'modal',
    errorTitle: t('decisionManager.messages.exportDecisionsError')
  });
};

export const assignDecisionsToUser = (payload, filterPayload, t) => (dispatch, getState) => {
  return dispatch({
    types: [ASSIGN_DECISION_MANAGER_REQUEST, ASSIGN_DECISION_MANAGER_SUCCESS, ASSIGN_DECISION_MANAGER_FAILURE],
    callAPI: (state, { customerId, userId }) => api.save(decisionManagerURL('assignDM'), payload),
    httpErrorTypes: {
      DEFAULT: decisionManagerActionErrorTypes.LOAD_DECISION_MANAGER_HISTORY,
      404: {
        type: decisionManagerActionErrorTypes.LOAD_DECISION_MANAGER_HISTORY,
        message: t('decisionManager.messages.noSuspendedTransactionsFound')
      }
    },
    dispatchOnSuccess: [
      () => clearDecisionManager(),
      () => loadDecisionManagerFilter(),
      () => loadDecisionManagerHistory(filterPayload, 'decisions', t)
    ],
    successDisplayType: 'toast',
    errorDisplayType: 'modal',
    errorTitle: t('transactions.error.assignError', { status: status })
  });
};

export const loadDMAssignableUsers = () => (dispatch, getState) => {
  return dispatch({
    types: [LOAD_ASSIGNABLE_USERS_REQUEST, LOAD_ASSIGNABLE_USERS_SUCCESS, LOAD_ASSIGNABLE_USERS_FAILURE],
    callAPI: (state, { customerId, userId }) => api.fetch(decisionManagerURL('getAvailableDMusers')),
    httpErrorTypes
  });
};

export const clearDecisionManager = () => {
  return { type: CLEAR_DECISION_MANAGER };
};
